import { object, mixed, number } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const MAX_INVITEE_LIMIT = 9999

const isBlankInviteesLimit = (value) => (
  value === '' || value == null || (typeof value === 'string' && value.trim() === '')
)

const isWholeNumberString = (value) => /^\d+$/.test(String(value).trim())

/** @param {{ useCrudValidationMessages?: boolean }} [options] CRUD-only free-form messages when true. */
export const getMaxInviteesValidationSchema = (eventType, { useCrudValidationMessages = false } = {}) => {
  if (!useCrudValidationMessages) {
    return object({
      inviteesLimit: mixed()
        .when(
          'isGroup',
          {
            is: () => eventType.isGroup,
            then: number()
              .typeError(I18n.t('errors.messages.not_a_number'))
              .integer()
              .required(I18n.t('activerecord.errors.models.event_type_base.attributes.invitees_limit.blank'))
              .lessThan(MAX_INVITEE_LIMIT + 1, I18n.t('errors.messages.less_than_or_equal_to', { count: MAX_INVITEE_LIMIT }))
              .moreThan(1, I18n.t('errors.messages.greater_than', { count: 1 }))
          }
        )
    })
  }

  const blankMessage = I18n.t(
    'publisher.event_type_editor_crud.meeting_details.group_size.validation.blank'
  )
  const notANumberMessage = I18n.t(
    'publisher.event_type_editor_crud.meeting_details.group_size.validation.not_a_number'
  )
  const maxMessage = I18n.t(
    'publisher.event_type_editor_crud.meeting_details.group_size.validation.max',
    { count: MAX_INVITEE_LIMIT }
  )
  const greaterThanMessage = I18n.t('errors.messages.greater_than', { count: 1 })

  return object({
    inviteesLimit: mixed()
      .when(
        'isGroup',
        {
          is: () => eventType.isGroup,
          then: mixed()
            .test('required', blankMessage, (value) => !isBlankInviteesLimit(value))
            .test('whole-number', notANumberMessage, (value) => (
              isBlankInviteesLimit(value) || isWholeNumberString(value)
            ))
            .test('min', greaterThanMessage, (value) => {
              if (isBlankInviteesLimit(value) || !isWholeNumberString(value)) return true
              return Number(value) > 1
            })
            .test('max', maxMessage, (value) => {
              if (isBlankInviteesLimit(value) || !isWholeNumberString(value)) return true
              return Number(value) <= MAX_INVITEE_LIMIT
            })
        }
      )
  })
}
